/**
 * The living mark — Viv (BRAND.md §6). An organic blob that morphs slowly via
 * the `.cf-blob` rule in index.css (reduced-motion freezes it). Two variations:
 *
 *  - `filled` (default): the signature green→violet gradient, softly glowing.
 *  - `outline`: NO fill — lit only by a layered green→violet glow (the "blank"
 *    specimen). Same morph.
 *
 * Used as the agent (Viv) avatar in chats + the top-left profile button. Keep it
 * sparing elsewhere.
 */
export function Blob({
  size = 24,
  glow = true,
  variant = 'filled',
}: {
  size?: number;
  glow?: boolean;
  variant?: 'filled' | 'outline';
}) {
  const filledShadow = glow
    ? `0 0 ${Math.round(size * 0.6)}px ${-Math.round(size * 0.15)}px var(--color-accent-2)`
    : 'none';
  // Layered green + violet glow so the shadow reads as the brand gradient.
  const outlineShadow =
    `0 0 ${Math.round(size * 0.55)}px ${-Math.round(size * 0.1)}px var(--color-accent-2),` +
    `0 0 ${Math.round(size * 0.75)}px ${-Math.round(size * 0.05)}px var(--color-accent)`;
  const outline = variant === 'outline';
  return (
    <span
      className="cf-blob"
      aria-hidden="true"
      style={{
        width: size,
        height: size,
        display: 'inline-block',
        flex: 'none',
        background: outline ? 'transparent' : 'var(--grad)',
        borderRadius: '42% 58% 60% 40% / 55% 45% 55% 45%',
        boxShadow: outline ? outlineShadow : filledShadow,
      }}
    />
  );
}
